import { StyleSheet, View } from 'react-native';

import { SectionCard } from '@/components/SectionCard';
import { StepNumber } from '@/components/StepNumber';
import { Text } from '@/components/Text';
import { spacing } from '@/constants/theme';

export type DealWhatYouGetCardProps = {
  /** Server-authored reward lines (`marketing_copy.hero_body_lines`). */
  lines?: readonly string[];
  testID?: string;
};

/**
 * "What you get" on the deal page: the deal's reward lines, numbered so a
 * two-part reward ($35 from us + SoFi's stock) reads as two things you get.
 * Renders nothing for a deal without lines.
 */
export function DealWhatYouGetCard({ lines, testID }: DealWhatYouGetCardProps) {
  if (!lines?.length) return null;
  return (
    <SectionCard title="What you get" testID={testID}>
      {lines.map((line, i) => (
        // Index key: two server lines could read the same.
        <View key={i} style={styles.row}>
          <StepNumber number={i + 1} />
          <Text style={styles.text}>{line}</Text>
        </View>
      ))}
    </SectionCard>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: spacing.md,
  },
  text: {
    flex: 1,
  },
});
